/**
 * Where `RowMenu` puts its list, as a function of three rectangles. In a file of its own because a
 * component file that also exports a function loses React's fast refresh, and because jsdom has no
 * layout: every rectangle there is zero, so `tests/row-menu.test.tsx` proves the placement here.
 * Added 2026-10-07, build round 16.
 */

/** The gap between the button and the list, and the least room kept to the viewport's edge. */
const GAP = 4;
const EDGE = 8;

/**
 * Where the list goes: under the button, right edges aligned, unless that runs off the viewport.
 */
export function placeRowMenu(
  button: { top: number; bottom: number; right: number },
  menu: { width: number; height: number },
  viewport: { width: number; height: number }
): { top: number; left: number } {
  let top = button.bottom + GAP;

  if (top + menu.height > viewport.height - EDGE) {
    const above = button.top - GAP - menu.height;
    top = above >= EDGE ? above : Math.max(EDGE, viewport.height - EDGE - menu.height);
  }

  const left = Math.min(
    Math.max(EDGE, button.right - menu.width),
    Math.max(EDGE, viewport.width - EDGE - menu.width)
  );

  return { top, left };
}
